import { ICommunities } from "../../services/header.services";

export const hasCommunityScimGroupMappings = (community?: ICommunities) =>
  (community?.scim_group_mappings ?? []).some(
    (mapping) => mapping.community_id === community?.id
  );
